import * as React from 'react';
import styled from 'styled-components';
import {useRoute} from 'react-router5';
import {getWebinarByID} from 'api/webinar/requests';
import {WebinarObject} from 'api/webinar/types';
import validateResponse from 'helpers/validate-response';
import isError from 'helpers/isError';
import {IconLoading} from 'icons';
import {Helmet} from 'react-helmet';
import {Viewer} from "../components/Viewer";
import {WebinarViewer} from "../components/WebinarViewer";

const Viewport = styled.iframe`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  
  width: 100%;
  height: 100%;
`;

/**
 * The view webinar page
 * @constructor
 */
export default function ViewWebinar(): React.ReactElement {
  const {route: {params}} = useRoute();

  const [
    webinar,
    setWebinar,
  ] = React.useState<WebinarObject | undefined>(undefined);

  React.useEffect(() => {
    getWebinarByID(params.id).then((response) => {
      validateResponse(response);
      !isError(response) && (
        response && setWebinar(response)
      );
    });
  }, []);

  return (
    <React.Fragment>
      <Helmet>
        <title>GrowPlace / Просмотр трансляции</title>
      </Helmet>
      {webinar ? (
        <WebinarViewer
          webinar={{...webinar, tags: ['click', 'nick']}}
        />
      ) : <IconLoading />}
    </React.Fragment>
  );
}
